import { OurIntlShape } from '@/i18n/typing'
import { CustomizedLabel } from '@/types/schema/directory/kol-management'

export const BUILT_IN_CUSTOMIZED_LABEL_AMOUNT = 2
const RECOMMENDED_LABEL_ID = -1
const UNRECOMMENDED_LABEL_ID = -2
export const BUILT_IN_CUSTOMIZED_LABEL_IDS: number[] = [
  RECOMMENDED_LABEL_ID,
  UNRECOMMENDED_LABEL_ID,
] as const

const getCustomizedLabelLocalizedName = (
  resource: CustomizedLabel,
  formatMessage: OurIntlShape['formatMessage'],
): string => {
  switch (resource.id) {
    case RECOMMENDED_LABEL_ID:
      return formatMessage({ id: 'general:column_title_recommended' })
    case UNRECOMMENDED_LABEL_ID:
      return formatMessage({ id: 'general:column_title_unrecommended' })
    default:
      return resource.name
  }
}

export default getCustomizedLabelLocalizedName
